import { Resource } from '@centers/interfaces/resource';

// Entity
export interface AccessPointInterface {
  id?: number;
  center_id?: number;
}

export interface AccessPointFormModelInterface {
  id: number;
  center_id: number;
}

// Permission
export const ActivitySessionWaitingContactPermissionName: string =
  'activity_session_waiting_contact';

// Table Filters interfaces
export interface AccessPointDefaultFilterTableInterface {
  search?: string;
}

// Table items interface
export interface AccessPointDefaultTableItemInterface {
  id: number;
  center_id: number;
}
